import type { Permission } from 'src/models/Permission'
import { UserDataService } from './UserDataService'

export const hasPermission = (permiso: Permission) => {
  const permisosUser = UserDataService.getPermissions()
  return permisosUser.includes(permiso)
}
